import { useMutation } from '@tanstack/react-query';

import { updateCompanyProfile } from '../api';

export const useUpdateCompanyProfile = () => {
  return useMutation({
    mutationKey: ['update'],
    mutationFn: updateCompanyProfile,
    onSuccess: (_data) => {},
    onError: (_error) => {},
  });
};
